import { Configuration } from "Models/configuration";
import { Consumer } from "Models/consumer";
import { Message } from "Models/message";
import { Node } from "Models/node";
import { Partition } from "Models/partition";
import { Producer } from "Models/producer";
import {
    ClearLogsAction,
    CLEAR_LOGS,
    SetConfigurationAction,
    SetConsumersAction,
    AddLogMsgAction,
    UpdateLogMsgAction,
    SetNodesAction,
    SetPartitionsAction,
    SetProducersAction,
    SET_CONFIGURATION,
    SET_CONSUMERS,
    ADD_LOG_MESSAGE,
    UPDATE_LOG_MESSAGE,
    SET_NODES,
    SET_PARITITIONS,
    SET_PRODUCER,
    SetLogAction,
    SET_LOG,
    SetGlobalStateAction,
    SET_GLOBAL,
    UpdatePartitionAction,
    UPDATE_PARTITION,
} from "./actionTypes";
import { GlobalState } from "./reducers/globals";

export const setGlobal = (
    state: Partial<GlobalState>
): SetGlobalStateAction => ({
    type: SET_GLOBAL,
    payload: state,
});

export const addLogMessage = (uid: string, msg: Message): AddLogMsgAction => ({
    type: ADD_LOG_MESSAGE,
    payload: { uid, msg },
});

export const updateLogMessage = (
    uid: string,
    msg: Message
): UpdateLogMsgAction => ({
    type: UPDATE_LOG_MESSAGE,
    payload: { uid, msg },
});

export const setLog = (uid: string, log: Message[]): SetLogAction => ({
    type: SET_LOG,
    payload: { uid, log },
});

export const clearLogs = (): ClearLogsAction => ({ type: CLEAR_LOGS });

export const setConfiguration = (
    config: Configuration
): SetConfigurationAction => ({
    type: SET_CONFIGURATION,
    payload: { config },
});

export const setConsumers = (consumers: Consumer[]): SetConsumersAction => ({
    type: SET_CONSUMERS,
    payload: { consumers },
});

export const setNodes = (nodes: Node[]): SetNodesAction => ({
    type: SET_NODES,
    payload: { nodes },
});

export const setPartitions = (
    partitions: Partition[]
): SetPartitionsAction => ({
    type: SET_PARITITIONS,
    payload: { partitions },
});

export const setProducer = (producer: Producer | null): SetProducersAction => ({
    type: SET_PRODUCER,
    payload: { producer },
});

export const updatePartition = (
    partition: Partition
): UpdatePartitionAction => ({
    type: UPDATE_PARTITION,
    payload: { partition },
});
